import { ChevronLeft, Loader2 } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { Button } from "../ui/button";

/**
 * Einheitliches Layout-Shell für alle Flow-Screens (Schnellflows und
 * Step-Wizards). Oberer Back-Link + Titel, Scroll-Area, Primary-CTA
 * unten (Sticky über der Bottom-Nav).
 */
export function FlowShell({
    title,
    subtitle,
    kind = "Flow",
    back = -1,
    onBack,
    backLabel = "zurück",
    onSubmit,
    submitLabel = "Buchen",
    submittingLabel = "Buchen...",
    submitTestId,
    submitDisabled = false,
    submitting = false,
    stepIndicator = null,
    testId,
    children,
}) {
    const navigate = useNavigate();
    return (
        <section className="pb-32" data-testid={testId}>
            <header className="mb-5 flex items-start justify-between gap-3">
                <button
                    type="button"
                    className="pw-tap -ml-2 flex h-10 w-10 items-center justify-center rounded-md text-muted-foreground hover:text-foreground"
                    onClick={onBack || (() => navigate(back))}
                    aria-label={backLabel}
                    data-testid={`${testId}-back`}
                >
                    <ChevronLeft className="h-5 w-5" />
                </button>
                <div className="flex-1">
                    <div className="text-xs uppercase tracking-[0.2em] text-muted-foreground">
                        {kind}
                    </div>
                    <h1 className="text-2xl font-bold tracking-tight text-foreground">
                        {title}
                    </h1>
                    {subtitle ? (
                        <p className="mt-1 text-xs text-muted-foreground">{subtitle}</p>
                    ) : null}
                </div>
                {stepIndicator ? (
                    <div className="text-xs uppercase tracking-[0.2em] text-primary">
                        {stepIndicator}
                    </div>
                ) : null}
            </header>

            <div className="flex flex-col gap-5">{children}</div>

            {onSubmit ? (
                <div
                    className="fixed inset-x-0 bottom-[64px] z-20 border-t border-border bg-card/95 px-4 py-3 backdrop-blur"
                    data-testid={`${testId}-cta-bar`}
                >
                    <Button
                        type="button"
                        onClick={onSubmit}
                        disabled={submitDisabled || submitting}
                        className="pw-primary-cta mx-auto block w-full max-w-md bg-primary text-primary-foreground hover:bg-primary/90"
                        data-testid={submitTestId || `${testId}-submit`}
                    >
                        {submitting ? (
                            <>
                                <Loader2 className="mr-2 h-4 w-4 animate-spin" />
                                {submittingLabel}
                            </>
                        ) : (
                            submitLabel
                        )}
                    </Button>
                </div>
            ) : null}
        </section>
    );
}
